
import { defineComponent } from 'vue'
import DownloadMenu from '@/components/organisms/statistics/DownloadMenu.vue'

export default defineComponent({
  components: {
    DownloadMenu,
  }
})
